<template>
  <div class="page-subnavbar">
    <slot />
  </div>
</template>